module.exports = __webpack_public_path__ + "img/logo1.fb516a6f.png";